<div class="loader-container" [ngClass]="{reverse: reverse}">
    <video src="/assets/media/audiowave.mp4" autoplay loop></video>
</div>
